import React, { useEffect, useState } from "react";
import styled, { keyframes } from 'styled-components';
import { ReactComponent as HourglassLogo } from './hets.svg';
import { SketchPicker } from 'react-color'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faArrowLeft, faEdit, faQuestion } from "@fortawesome/free-solid-svg-icons";
import { useWindowDimensions } from './widgets/WindowsDimensionProvider';

export default function FindColorTwo() {
  const [color, SetColor] = useState({
    r: 19,
    g: 116,
    b: 186,
    a: 1
  });
  const [hex, setHex] = useState('#1374BA');
  const [r, setR] = useState("19");
  const [g, setG] = useState("116");
  const [b, setB] = useState("186");
  const [a, setA] = useState("1");
  const handleChange = ({ rgb, hex }) => {
    SetColor(rgb);
    setR(rgb.r);
    setG(rgb.g);
    setB(rgb.b);
    setA(rgb.a);
    setHex(hex);
  }
  const presets = [
    'black',
    'white',
    'red',
    'green',
    'blue',
    'purple',
    'orange',
    'yellow',
    "gray"
  ];

  const [showPop, setShowPop] = useState(false);
  const [left, setLeft] = useState("-250px");
  const [loadA, setLoadA] = useState(false);
  const [loadB, setLoadB] = useState(false);
  const [Z, setZ] = useState("0");
  const handleClose = e => {
    e.preventDefault();
    setLeft("-250px");
  }
  const handlePop = () => {
    setLeft("0px");
  }
  const handleFakePop = () => {
    setLoadB(false);
    setZ("0");
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoadA(true)
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  const { width } = useWindowDimensions()

  return (<>
    <TopRow>
      <Box pad={width > 425 ? "30" : "0"} size={width > 425 ? "300" : "280"}>
        <CHourglassLogo r={r} g={g} b={b} a={a} />
      </Box>
    </TopRow>
    <Info width={width < 426 ? "100%" : "400px"}>
      <CodeWrapper index={Z} >
        <Row>
          <Label>Hex code</Label>
          <HexCode>{hex}</HexCode>
        </Row>
        <Below>
          <Label>R (Red)</Label>
          <SingleCode>{r}</SingleCode>
          <Help>0-255 (Changes the amount of red)</Help>
          <Label>G (Green)</Label>
          <SingleCode>{g}</SingleCode>
          <Help>0-255 (Changes the amount of green)</Help>
          <Label>B (Blue)</Label>
          <SingleCode>{b}</SingleCode>
          <Help>0-255 (Changes the amount of blue)</Help>
          <Label>A (Alpha)</Label>
          <SingleCode>{a}</SingleCode>
          <Help>0.00-1.00 (Changes transparency)</Help>
        </Below>
      </CodeWrapper>
    </Info>
    <PopOut left={left}>
      <Header>
        Color Picker
         <IconWrap onClick={handleClose}></IconWrap>
      </Header>
      <SketchPicker color={color} onChange={handleChange} presetColors={presets} />
    </PopOut>
    {!loadA && (
      <PopButton onClick={handlePop}>
        <FontAwesomeIcon icon={faEdit} />
      </PopButton>
    )}
    {loadA && (<>
      <OnLoad onClick={() => { setLoadA(false); setLoadB(true); setZ("10") }}>
        <FakePopButton onClick={() => { setLoadA(false); setLoadB(true); setZ("10") }}>
          <FontAwesomeIcon icon={faEdit} />
        </FakePopButton>
      </OnLoad>
      <Pointer onClick={() => { setLoadA(false); setLoadB(true); setZ("10") }}>
        <Move><FontAwesomeIcon icon={faArrowLeft} /></Move>
        <Size>Open the color picker to change the color of the logo</Size>
      </Pointer>
    </>)}
    {loadB && (<>
      <OnL onClick={handleFakePop} >
      </OnL>
      <Pointer2 top={width < 426 ? "30" : "37"} onClick={handleFakePop} >
        <Size>HEX code and RGB code will render here</Size>
        <MoveTwo><FontAwesomeIcon icon={faArrowDown} /></MoveTwo>
      </Pointer2>
    </>)}
    <Float onClick={() => { setLoadA(true); setLeft("-250px"); }}><FontAwesomeIcon icon={faQuestion} /></Float>
  </>)
}

const Float = styled.div`
  position: fixed;
  bottom: 30px;
  right: 30px;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0,0,0,.12);
  transition: box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
  padding: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  border: none;
  outline: none;
  line-height: inherit;
  user-select: none;
  overflow: visible;
  border-radius: 50%;
  background-color: #6200ee;
  color: white;
  cursor: pointer;
  height: 36px;
  width: 36px;
  &:hover, :focus {
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0,0,0,.12);
  }
`;
const bounce = keyframes`
0%   { transform: translateY(20px); }
        50%  { transform: translateY(-20px); }
        100% { transform: translateY(20px); }
`;

const opac = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 0.6;
  }
`;

const Point = styled.div`
  z-index: 5;
  color: white;
  position: fixed;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const Pointer = styled(Point)`
  top: 26%;
  left: 70px;
`;

const Pointer2 = styled(Point)`
  top: ${({ top }) => top}%;
  display: flex;
  flex-direction: column;
  left: 0;
  width: 100vw;
  & div:last-child {
    margin-top: 10px;
  }
`;

const Move = styled.div`
margin-right: 20px;
  animation: ${bounce} 0.85s linear infinite;
`;

const MoveTwo = styled.div`
  animation: ${bounce} 0.85s linear infinite;
`;
const Size = styled.div`
  font-size: 20px;
  font-weight: 500;
`;

const OnL = styled.div`
  top: 0;
  left: 0;
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 3;
  color: white;
  background-color: rgb(0,0,0);
  opacity: 0.6;

`;
const OnLoad = styled(OnL)`
transition: all 0.2s linear;
  animation ${opac} 0.2s linear;
`;

const IconWrap = styled.div`
  background-color: red;
  color: red;
  cursor: pointer;
  border-radius: 50%;
  height: 15px;
  width: 15px;
`;
const Header = styled.div`
  margin: -10px -10px 10px -10px;
  border-top-right-radius: 10px;
  background-color: #212121;
  color: white;
  font-weight: 500;
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: space-between;
  padding: 10px;
`;
const PopOut = styled.div`
  background-color: #464646;
  display: flex;
  padding: 10px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  flex-direction: column;
  position: fixed;
  top: 20%;
  left: ${({ left }) => left};
  z-index: 4;
  transition: all 0.2s linear;
`;

const PopButton = styled.div`
z-index: 3;
color: blue;
cursor: pointer;
  position: fixed;
  top: 25%;
  left: 0;
  display: flex;
  padding: 20px;
  background-color: white;
    box-shadow: rgba(0, 0, 0, 0.12) 0px 2px 10px, rgba(0, 0, 0, 0.16) 0px 2px 5px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
`;
const FakePopButton = styled(PopButton)`
  box-shadow: blue 0px 2px 10px, rgba(0, 0, 0, 0.16) 0px 2px 5px;
  z-index: 5;
`;
const TopRow = styled.div`
 margin: 0 auto;
`;
const Help = styled.div`
  font-size:12px;
  color: rgba(128,128,128,0.8);
`;
const Row = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  & div:first-child {
    padding-right: 10px;
  }
`;

const Below = styled.div`

  padding-top: 20px;
  display: grid;
  grid-template-columns: auto auto auto;
  grid-gap: 10px;
  align-items: baseline;
`;

const HexCode = styled.div`
  border-bottom: 2px solid #194D33;
  padding: 0 5px 5px 0;
  width: fit-content;
`;
const SingleCode = styled.div`
  border-bottom: 1px solid rgba(128,128,128,0.4);
`;
const CodeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: white;
  padding: 10px;
  box-shadow: rgba(0, 0, 0, 0.12) 0px 2px 10px, rgba(0, 0, 0, 0.16) 0px 2px 5px;
  border-radius: 2px;
  z-index: ${({ index }) => index};
`;
const Label = styled.div`
  color: gray;
  font-size: 12px;
`;
const Info = styled.div`
  margin: 0 auto;
  display: flex;
  width: ${({ width }) => width};
`;


const Box = styled.div`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  padding: ${({ pad }) => pad}px;
`;

const CHourglassLogo = styled(HourglassLogo)`
 & .cls-6 {
   fill: rgba(${({ r }) => r}, ${({ g }) => g}, ${({ b }) => b}, ${({ a }) => a});
}
`;


